import { render, staticRenderFns } from "./DisabledRegistrationInputComponent.vue?vue&type=template&id=33b0501f"
import script from "./DisabledRegistrationInputComponent.vue?vue&type=script&lang=ts"
export * from "./DisabledRegistrationInputComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports